import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ExhibitorType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { EXHIBITORS } from "../../utils/constants";

export const createExhibitor = async (data: ExhibitorType) => await post<ExhibitorType, string>(EXHIBITORS, data);
export const updateExhibitor = async (data: ExhibitorType) => await put<ExhibitorType, string>(EXHIBITORS, data);

export const getExhibitors = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${EXHIBITORS}?${queryParams.toString()}`;
    return await get<PagedResultsType<ExhibitorType>>(url);
};


export const getJudgeExhibitorIdByUserId = async (id:string) => {
    const url = `${EXHIBITORS}/${id}`;
    return await get<{idExhibitor:string,idJudge:string }>(url);
};
